export default {
    MAIN: {
        REAL_TIME: 'real-time-main-view',
        CONTROL: 'control-main-view',
        DASHBOARD: 'dashboard-main-view',
        ANALYTICS: 'analytics-main-view',
    },
    REAL_TIME_DETAIL: {
        DEFAULT: 'default-real-time-view',
        VEHICLE: 'vehicle-real-time-view',
        STOP: 'stop-real-time-view',
        ROUTE: 'route-real-time-view',
        LIST: 'list-real-time-view',
    },
    SECONDARY_PANEL: {
        ALERTS: 'secondary-panel-alerts-view',
    },
    CONTROL_DETAIL: {
        BLOCKS: 'control-blocks-view',
        ROUTES: 'control-routes-view',
        RECURRING_CANCELLATIONS: 'control-recurring-cancellations-view',
        STOP_GROUPS: 'control-stop-groups-view',
        ALERTS: 'control-alerts',
        FLEETS: 'control-fleets',
        DISRUPTIONS: 'control-disruptions',
        INCIDENTS: 'control-incidents',
        TRIP_REPLAYS: 'control-trip-replay',
        DATA_MANAGEMENT: 'control-data-management',
        STOP_MESSAGES: 'control-messages',
        NOTIFICATIONS: 'control-notifications',
    },
    CONTROL_DETAIL_ROUTES: {
        ROUTES_ROUTE_VARIANTS_TRIPS: 'control-routes-view-routes-route-variants-trips',
        ROUTES_TRIPS: 'control-routes-view-routes-trips',
        ROUTE_VARIANTS_TRIPS: 'control-routes-view-route-variants-trips',
        TRIPS: 'control-routes-view-trips',
    },
    ANALYTICS_DETAIL: {
        OCCUPANCY: 'analytics-occupancy',
    },
};
